export default __webpack_public_path__ + "static/media/AnimalsOrange_00.e84f288d.png";